import { buildGlobalAction, buildInlineComputedView } from "./../builder.js";
class LoopsNamespace {
  constructor(clientOrParent) {
    this.clientOrParent = clientOrParent;
    /** Executes the createUserById global action. */
    this.createUserById = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "createUserById",
      operationName: "createUserById",
      operationReturnType: "LoopsCreateUserById",
      namespace: "loops",
      variables: { userId: { required: false, type: "String" } }
    });
    /** Executes the sendEventByUserId global action. */
    this.sendEventByUserId = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "sendEventByUserId",
      operationName: "sendEventByUserId",
      operationReturnType: "LoopsSendEventByUserId",
      namespace: "loops",
      variables: {
        userId: { required: false, type: "String" },
        eventName: { required: false, type: "String" }
      }
    });
    /** Executes the updateUserById global action. */
    this.updateUserById = buildGlobalAction(this, {
      type: "globalAction",
      functionName: "updateUserById",
      operationName: "updateUserById",
      operationReturnType: "LoopsUpdateUserById",
      namespace: "loops",
      variables: { userId: { required: false, type: "String" } }
    });
    /** Executes an inline computed view. */
    this.view = buildInlineComputedView(this, {
      type: "computedView",
      operationName: "gellyView",
      functionName: "view",
      gqlFieldName: "gellyView",
      namespace: "loops",
      variables: {
        query: { type: "String", required: true },
        args: { type: "JSONObject" }
      }
    });
    this.connection = this.clientOrParent.connection;
  }
}
export {
  LoopsNamespace
};
//# sourceMappingURL=loops.js.map
